<div class="crewrepeater" *ngFor="let crewbio of cruisebios; let i=index;">
    <div class="borderaround">
        <div>

            <a *ngIf="!crewbio.expander" (click)="crewbio.expander = !crewbio.expander"><i
                    class="fa-solid fa-circle-plus fa-lg"></i><span class="action">{{crewbio.crewRole}} <span
                        class="officername">{{crewbio.crwName}}</span></span></a>
            <a *ngIf="crewbio.expander" (click)="crewbio.expander = !crewbio.expander"><i
                    class="fa-solid fa-circle-minus fa-lg"></i><span class="action">{{crewbio.crewRole}}</span></a>
        </div>
        <div class="row innerexpand" *ngIf="crewbio.expander">
            <div class="col-12">
                <div class="officerpic float-end" *ngIf="crewbio.crbBioImageLink!=null">
                    <img src="{{imagepath}}bioimages/{{crewbio.crbBioImageLink}}" class="img-fluid" alt=""
                        onerror="this.style.display='none'">
                </div>
                <div class="officername">{{crewbio.crwName}}</div>
                <div class="officerbio" *ngIf="crewbio.crbBioText!='null'">{{crewbio.crbBioText}}</div>
                <div *ngIf="crewbio.crlOBPortalPhoneDisp && pagemask == false" class="officerphone">
                    <span class="phonetext">Contact Info:&nbsp;</span>
                    <a href="tel:{{crewbio.spcPhoneNumber}}">{{crewbio.spcPhoneNumber | phoneFormat}}</a>
                </div>

            </div>

        </div>
    </div>
    <div class="twentypxtop"></div>
</div>